// extracted by mini-css-extract-plugin
module.exports = {"title":"zetttemplatedetails-module--title--24ndJ","subtitleItem":"zetttemplatedetails-module--subtitleItem--3vyQf","modifiedDate":"zetttemplatedetails-module--modifiedDate--2vgWy"};